import { useContext, useEffect, useState } from "react";
import { ClientContext } from "../../../contexts/clientProvider";
import { UserContext } from "../../../contexts/userProvider";
import LoadingSpinner from "../../Loader/load";
import TransferTable from "./components/TransferTable";
import { BiX } from "react-icons/bi";
import BaseButton from "../../General/FormsComp/Button/BaseButton";

const Servicos = ({ closeModal, clienteSelecionado }) => {
  const { getAllServices, getServicosPrestados, vincularServico, getClientes } = useContext(ClientContext);
  const { user } = useContext(UserContext);
  const [servicos, setServicos] = useState([]);
  const [servicosPrestados, setServicosPrestados] = useState(null);
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [leftTableData, setLeftTableData] = useState([]);
  const [rightTableData, setRightTableData] = useState([]);

  const buscarServicosPrestados = async () => {
    try {
      const servicosPrestados = await getServicosPrestados(cliente.id);
      setServicosPrestados(servicosPrestados);
    } finally {
      setLoading(false);
    }
  };

  const buscarServicos = async () => {
    try {
      const servicos = await getAllServices();
      setServicos(servicos);
    } finally {
      setLoading(false);
    }
  };

  const salvarServicosPrestados = async () => {
    let newServicosPrestadosAdd = [];
    let newServicosPrestadosRemove = [];

    for (let i = 0; i < rightTableData.length; i++) {
      const servico = rightTableData[i];
      const existeNoServicosPrestados = servicosPrestados.some(
        (servicoPrestado) => servicoPrestado.idservico === servico.id
      );

      if (!existeNoServicosPrestados) {
        newServicosPrestadosAdd.push({
          idcliente: cliente.id,
          idservico: servico.id,
          created_at: new Date().toISOString().slice(0, 19).replace("T", " "),
          updated_at: new Date().toISOString().slice(0, 19).replace("T", " "),
          id_usuario: user.id,
          usuario: user.nome,
        });
      }
    }

    for (let i = 0; i < servicosPrestados.length; i++) {
      const servicoPrestado = servicosPrestados[i];
      const existeNoRightTableData = rightTableData.some(
        (servico) => servico.id === servicoPrestado.idservico
      );

      if (!existeNoRightTableData) {
        newServicosPrestadosRemove.push(servicoPrestado);
      }
    }

    if (newServicosPrestadosAdd.length > 0 || newServicosPrestadosRemove.length > 0) {
      await vincularServico(newServicosPrestadosAdd, newServicosPrestadosRemove);
      // Atualizar os dados dos clientes para refletir as mudanças
      await getClientes();
    }
    setRightTableData([]);
    closeModal();
  };

  useEffect(() => {
    buscarServicos();
  }, []);

  useEffect(() => {
    let newClient = clienteSelecionado ? clienteSelecionado : {};
    setCliente(newClient);
  }, [clienteSelecionado]);

  useEffect(() => {
    if (!cliente) return;
    setLoading(true);
    buscarServicosPrestados();
  }, [cliente]);

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4'>
      <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col'>
        <div className='absolute top-4 right-4 z-10'>
          <button 
            onClick={() => closeModal()} 
            className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200'
          >
            <BiX className='w-8 h-8' />
          </button>
        </div>
        <div className='bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6'>
          <h1 className='text-2xl font-bold text-white mb-4'>Cadastro de Serviços Prestados</h1>
          <div className='text-white'>
            NOME DA PREFEITURA : <strong>{cliente && cliente.nome}</strong>
          </div>
        </div>
        <div className='flex-1 overflow-y-auto p-6'>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <TransferTable
            servicos={servicos}
            servicosPrestados={servicosPrestados}
            leftTableData={leftTableData}
            setLeftTableData={setLeftTableData}
            rightTableData={rightTableData}
            setRightTableData={setRightTableData}
          />
        )}
        </div>
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-4">
          <BaseButton
            onClick={() => closeModal()}
            variant="ghost"
            size="md"
          >
            Fechar
          </BaseButton>
          <BaseButton
            onClick={() => salvarServicosPrestados()}
            variant="primary"
            size="md"
          >
            Salvar
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default Servicos;
